import React from 'react';
import {arrayOf, bool, exact, number, shape, string} from 'prop-types';
import styles from './BuildingLoadingView.module.styl';
import {Heading} from 'uikit/components';
import {toShortDateStringLocale} from 'utils';
import BuildingLoadingSummaryCard from '../BuildingLoadingSummaryCard/BuildingLoadingSummaryCard';
import BuildingLoadingEventsView from '../BuildingLoadingEventsView/BuildingLoadingEventsView';
import BuildingLoadingSchoolsView from '../BuildingLoadingSchoolsView/BuildingLoadingSchoolsView';
import BuildingLoadingPlacesView from '../BuildingLoadingPlacesView/BuildingLoadingPlacesView';

export default function BuildingLoadingView({data}) {
    return (
        <>
            <Heading size={'h1'} className={styles.heading} name="building-loading-header">
                {data.sportObjectInfo.name}: загрузка
                c {toShortDateStringLocale(data.reportDates.start)} по {toShortDateStringLocale(data.reportDates.end)}
            </Heading>
            <div className={styles.subHeader} data-test-name="building-loading-subheader">Общая информация об объекте</div>
            <BuildingLoadingSummaryCard
                buildingData={data.sportObjectInfo}
            />
            {data.schoolsData.length !== 0 &&
                <BuildingLoadingSchoolsView schoolsData={data.schoolsData}
                                            schoolsCount={data.sportObjectInfo.schoolsCount}/>}
            {data.placesData.length !== 0
                && <BuildingLoadingPlacesView placesData={data.placesData}
                                              startDate={data.reportDates.start}
                                              endDate={data.reportDates.end}
                                              showCameraDetectionData={data.showCameraDetectionData}/>}
            {data.eventsData.length !== 0 &&
                <BuildingLoadingEventsView eventsData={data.eventsData}/>}
        </>
    )
}

BuildingLoadingView.propTypes = {
    data: exact({
        reportDates: shape({
            start: string.isRequired,
            end: string.isRequired
        }).isRequired,
        schoolsData: arrayOf(shape({
            id: number.isRequired,
            name: string.isRequired
        })),
        sportObjectInfo: shape({
            id: number.isRequired,
            name: string.isRequired,
            schoolName: string.isRequired,
            sportTypesCount: number.isRequired,
            throughput: number.isRequired,
            workingDaysCount: number.isRequired,
            maxDailyCapacity: number.isRequired,
            loadingPercent: number.isRequired,
            municipalityName: string.isRequired,
            sportObjectPlaceCount: number.isRequired,
            sportObjectParticipantCount: number.isRequired,
            schoolsCount: number.isRequired
        }),
        placesData: arrayOf(
            shape({
                id: number.isRequired,
                name: string.isRequired,
                throughput: number.isRequired,
                workingDays: arrayOf(shape({
                    day: string,
                    startTime: string,
                    endTime: string,
                })).isRequired,
                loadingPercent: number,
                participantsCount: number
            })),
        eventsData: arrayOf(
            shape({
                id: number.isRequired,
                name: string.isRequired,
                dateInterval: shape({
                    start: string.isRequired,
                    end: string.isRequired
                }).isRequired,
                eventStatus: string.isRequired,
                eventType: string.isRequired,
                sportType: string.isRequired,
                locationName: string.isRequired
            })),
        showCameraDetectionData: bool.isRequired
    }).isRequired
}